import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('TrainTravelPolicyModel')
export default class TrainTravelPolicyModel {
  @JsonProperty('max_price', Number, true) public maxPrice: number = undefined;
  @JsonProperty('comfort_class', String, true) public comfortClass: string = undefined;
}
